<div class="mlp-calendar">
    <div class="card mlp-card">
        <div class="card-header">
            <h2 class="sg-heading__h4 mb-0">
                <span
                    class="mlp-calendar-icon-label"
                    *ngIf="venueService.pitchData"
                >
                    <mlp-ng-icon
                        name="custom-flash"
                        class="sg-color__warn"
                    ></mlp-ng-icon>
                    Book Online at
                    {{ venueService.venueData?.data.attributes.name }}
                </span>

                <span *ngIf="!venueService.pitchData">
                    Venue Name - Calendar
                </span>
            </h2>
        </div>
        <div class="card-body px-0 pt-3">
            <div class="container mlp-calendar-title">
                <div class="row">
                    <div class="mlp-calendar-column-width-arrow-left"></div>
                    <div class="mlp-calendar-column-width-weekdays"></div>
                    <div
                        class="mlp-calendar-column-width-content d-flex flex-wrap justify-content-center mb-2"
                    >
                        <div
                            class="btn-group mr-1 mlp-calendar__date mb-1"
                            role="group"
                        >
                            <button
                                class="mlp-calendar__btn"
                                [ngClass]="{
                                    '-disabled': isBeforeOrEqualDate()
                                }"
                                type="button"
                                (click)="nextWeek(-7)"
                            >
                                <mlp-ng-icon name="arrow-left-1"></mlp-ng-icon>
                            </button>
                            <button
                                class="mlp-calendar-picker"
                                type="button"
                                (click)="firstDate()"
                            >
                                <span class="d-none d-md-inline-block"
                                    >{{
                                        slotCollection?.meta.filter.starts
                                            | dateFns: "eee d MMMM"
                                    }}
                                    -
                                    {{
                                        slotCollection?.meta.filter.ends
                                            | dateFns: "eee d MMMM"
                                    }}</span
                                >
                                <span class="d-md-none"
                                    >{{
                                        slotCollection?.meta.filter.starts
                                            | dateFns: "eee d MMM"
                                    }}
                                    -
                                    {{
                                        slotCollection?.meta.filter.ends
                                            | dateFns: "eee d MMM"
                                    }}</span
                                >
                            </button>
                            <button
                                class="mlp-calendar__btn cursor pointer"
                                type="button"
                                [ngClass]="{ '-disabled': nextWeekEmpty }"
                                (click)="nextWeek(7)"
                            >
                                <mlp-ng-icon name="arrow-right-1"></mlp-ng-icon>
                            </button>
                        </div>

                        <div class="d-md-inline-block">
                            <a
                                href=""
                                class="sg-link__btn mr-1"
                                (click)="before5PM(); (false)"
                                [ngClass]="{
                                    '-disabled':
                                        slotCollection?.data.length == 0 ||
                                        cutOffPointAmPmInPx == 0,
                                    '-active':
                                        ulCurrentPosition > cutOffPointAmPmInPx
                                }"
                            >
                                Morning
                            </a>

                            <a
                                href=""
                                class="sg-link__btn"
                                (click)="after5PM(); (false)"
                                [ngClass]="{
                                    '-disabled':
                                        slotCollection?.data.length == 0,
                                    '-active':
                                        ulCurrentPosition <= cutOffPointAmPmInPx
                                }"
                            >
                                Afternoon
                            </a>
                        </div>
                    </div>
                    <div class="mlp-calendar-column-width-arrow-right"></div>
                </div>
            </div>

            <div class="container mlp-calendar-content">
                <div *ngIf="slotCollection?.data.length == 0">
                    This venue is fully booked for this week; please try a later date or check back again in the future.
                </div>
                <div class="row" *ngIf="slotCollection?.data.length > 0">
                    <div
                        class="mlp-calendar__nav mlp-calendar-column-width-arrow-left d-flex flex-column justify-content-center align-items-end cursor pointer"
                        (click)="moveLeft()"
                    >
                        <mlp-ng-icon
                            name="arrow-left-1"
                            *ngIf="ulCurrentPosition != 0"
                        ></mlp-ng-icon>
                    </div>
                    <div class="mlp-calendar-column-width-weekdays">
                        <div
                            class="mlp-calendar-week"
                            *ngFor="let dayData of days; let last = last"
                        >
                            {{ dayData.date | dateFns: "eee" }} <br />
                            {{ dayData.date | dateFns: 'd\'o\'' }}
                        </div>
                    </div>
                    <div class="mlp-calendar-column-width-content">
                        <div class="scroll-container">
                            <div
                                style="
                                    transform: translateX(0px);
                                    width: 10000px;
                                "
                                draggableContainer
                                [@moveCalendarContent]="state"
                                [ulCurrentPosition]="ulCurrentPosition"
                                [ulMaxPosition]="ulMaxPosition"
                                [forceUlPositionEvent]="forceUlPositionEvent"
                                [tellCurrentUlPosition]="tellCurrentUlPosition"
                                [triggerSetupEvent]="triggerSetupEvent"
                                [allowClickEvent]="allowClickEvent"
                                [moveRightEvent]="moveRightEvent"
                            >
                                <div>
                                    <ng-container
                                        *ngFor="
                                            let dayData of days;
                                            let last = last
                                        "
                                    >
                                        <div
                                            class="mlp-slot rounded float-left"
                                            *ngFor="let slot of dayData.slots"
                                            [ngClass]="{
                                                'mlp-slot-avail':
                                                    slot.attributes
                                                        .availabilities > 0,
                                                'mlp-slot-booked':
                                                    slot.attributes
                                                        .availabilities == 0,
                                                'mlp-slot-na':
                                                    slot.attributes
                                                        .availabilities == null
                                            }"
                                            (click)="slotClick(slot)"
                                        >
                                            <div
                                                *ngIf="
                                                    slot.attributes
                                                        .availabilities != null
                                                "
                                            >
                                                <div class="mlp-line-one">
                                                    {{
                                                        slot.attributes.starts
                                                            | momentTimezone
                                                                : "HH:mm"
                                                    }}
                                                </div>
                                                <div class="mlp-line-two">
                                                    <span
                                                        *ngIf="
                                                            slot.attributes
                                                                .availabilities ===
                                                            0
                                                        "
                                                        >Booked</span
                                                    >

                                                    <span
                                                        *ngIf="
                                                            slot.attributes
                                                                .availabilities >
                                                                0 &&
                                                            slot.attributes
                                                                .price === 0
                                                        "
                                                        >Free</span
                                                    >

                                                    <span
                                                        *ngIf="
                                                            slot.attributes
                                                                .availabilities >
                                                                0 &&
                                                            slot.attributes
                                                                .price > 0
                                                        "
                                                    >
                                                        {{
                                                            slot.attributes
                                                                .price
                                                                | currency
                                                                    : slot
                                                                          .attributes
                                                                          .currency
                                                        }}
                                                    </span>
                                                </div>
                                                <div class="mlp-line-three">
                                                    {{
                                                        slot.attributes.starts
                                                            | differenceInMinutes
                                                                : slot
                                                                      .attributes
                                                                      .ends
                                                    }}
                                                    min
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mlp-calendar__nav mlp-calendar-column-width-arrow-right d-flex flex-column justify-content-center align-items-center cursor pointer"
                        *ngIf="ulCurrentPosition != ulMaxPosition"
                        (click)="moveRight()"
                    >
                        <mlp-ng-icon name="arrow-right-1"></mlp-ng-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<pf-checkout-popup [open]="openCheckoutPopup"></pf-checkout-popup>
